import * as React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "../Label/Label";
import { Skeleton } from "@/components/ui/skeleton";

interface SelectProps extends React.SelectHTMLAttributes<any> {
  options: { value: string; label: string | number; disabled?: boolean }[];
  placeholder: string;
  label?: string;
  disabled?: boolean;
  value?: string;
  helperText?: string;
  hasError?: boolean;
  onValueChange?: (value: string) => void;
  dataCy?: string;
  id?: string;
}

const CustomSelect = React.forwardRef<any, SelectProps>(
  (
    {
      options,
      placeholder,
      label,
      helperText,
      hasError,
      disabled,
      onValueChange,
      value,
      dataCy,
      id,
      ...rest
    },
    ref
  ) => {
    const handleChange = (newValue: string) => {
      if (onValueChange) {
        onValueChange(newValue);
      }
    };

    return (
      <React.Suspense fallback={<Skeleton className='w-full' />}>
        <div className='w-full flex flex-col gap-2'>
          {label && <Label>{label}</Label>}
          <Select
            value={value}
            onValueChange={handleChange}
            disabled={disabled}
          >
            <SelectTrigger
              className={`!h-[40px] !mt-0 bg-[#09090b] disabled:bg-bgDisabled text-muted !text-sm w-full ${
                helperText || hasError ? '!border-error' : 'border-colorBorder'
              }`}
              id={id}
              data-cy={dataCy}
            >
              <SelectValue className='!text-muted' placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {options?.map((option) => (
                  <SelectItem
                    data-cy='select-option'
                    data-testid='select-option'
                    key={option.value}
                    value={option.value}
                    disabled={option?.disabled}
                  >
                    {option.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
          {helperText && <p className='text-sm text-error'>{helperText}</p>}
        </div>
      </React.Suspense>
    );
  }
);

CustomSelect.displayName = "CustomSelect";

export default CustomSelect;
